export default __webpack_public_path__ + "static/media/LAR_PP.bb4b5bb6.png";